import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const ArrowDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M12 21.99C12.17 21.99 12.33 21.92 12.44 21.8001L20.82 13.0545C21.06 12.8046 21.05 12.4148 20.81 12.1749C20.57 11.935 20.18 11.945 19.94 12.1849L12.61 19.8211V2.61969C12.61 2.27986 12.33 2 11.99 2C11.65 2 11.37 2.27986 11.37 2.61969V19.8211L4.06 12.1849C3.82 11.935 3.43 11.935 3.19 12.1749C3.07 12.2949 3 12.4648 3 12.6247C3 12.7846 3.06 12.9345 3.17 13.0645L11.55 21.8101C11.66 21.93 11.82 22 11.99 22L12 21.99Z" />
  </svg>
)

export default withDefaultStyles(ArrowDown)
